import http from '@/services/http.service'
import moment from 'moment'
import { backgroundColors, borderColors } from '@/config/chartjs.config'

/**
 * 'Index' Store
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

export default {
  namespaced: true,
  state: {
    currentPeriod: null,
    periods: [],
    evaluations: [],
    totalEvaluations: 0
  },
  getters: {
    labels: state => {
      let result = []
      if (!state.currentPeriod) {
        return result
      }
      let startDate = moment(state.currentPeriod.startDate)
      let endDate = moment(state.currentPeriod.endDate)
      let difference = Math.ceil(endDate.diff(startDate, 'months', true))
      let format = startDate.year() === endDate.year() ? 'MMMM' : 'MMMM / YYYY'

      for (let i = 0; i < difference; i++) {
        result.push(moment(startDate).add(i, 'month').format(format))
      }
      console.log(result)
      return result
    },
    totalEvaluations (state) {
      return state.totalEvaluations
    },
    datasets: (state, getters) => {
      let result = [
        {
          backgroundColor: backgroundColors[0],
          borderColor: borderColors[0],
          data: [],
          label: 'Terminadas'
        }, {
          backgroundColor: backgroundColors[1],
          borderColor: borderColors[1],
          data: [],
          label: 'Pendientes'
        }
      ]

      let allCompleted = 0
      let allUnsolved = 0

      for (let i = 0; i < getters.labels.length; i++) {
        let month = getters.labels[i]
        let completed = 0
        let unsolved = 0
        if (getters.evaluations[month] && getters.evaluations[month]['unsolved']) {
          unsolved = getters.evaluations[month]['unsolved']
        }
        // Completed evaluations
        if (getters.evaluations[month] && getters.evaluations[month]['complete']) {
          completed = getters.evaluations[month]['complete']
        }

        allUnsolved += unsolved - completed
        allCompleted += completed

        // Completed
        result[0].data[i] = allCompleted

        // Unsolved
        result[1].data[i] = allUnsolved
      }

      return result
    },
    evaluations: state => {
      return state.evaluations
    },
    currentPeriod: state => {
      return state.currentPeriod
    }
  },
  mutations: {
    totalEvaluations (state, payload) {
      state.totalEvaluations = payload
    },
    evaluations (state, payload) {
      state.evaluations = payload
    },
    currentPeriod (state, payload) {
      state.currentPeriod = payload
    }
  },
  actions: {
    evaluations ({commit, state}, payload) {
      if (!state.currentPeriod.id) {
        commit('evaluations', [])
        return
      }
      let options = payload || {}
      options.limit = 100000
      options.with = 'assignment'
      options.fields = 'status,assignmentId'
      options['filters[where][periodId][eq]'] = state.currentPeriod.id
      http.get('evaluations', {params: options})
        .then(({data}) => {
          let datasets = {}

          let startDate = moment(state.currentPeriod.startDate)
          let endDate = moment(state.currentPeriod.endDate)
          let format = startDate.year() === endDate.year() ? 'MMMM' : 'MMMM / YYYY'

          data.items.forEach(function (element) {
            let month = element.assignment ? moment(element.assignment.startDate).format(format) : moment(element.startDate).format(format)
            if (!datasets[month]) {
              datasets[month] = {}
            }
            if (!datasets[month][element.status]) {
              datasets[month][element.status] = 0
            }
            datasets[month][element.status] += 1
          })
          console.log('datasets', datasets)

          commit('evaluations',
            datasets
          )
          commit('totalEvaluations',
            data.pagination.total
          )
        }).catch(e => {
          console.log(e)
        })
    },
    setCurrentPeriod ({commit}, payload) {
      return http.get('periods/' + payload.id)
        .then(({data}) => {
          commit('currentPeriod', data)
        })
    },
    currentPeriod ({commit}) {
      return http.get('periods', {
        params: {
          'filters[where][startDate][lte]': moment().format(),
          'filters[where][endDate][gte]': moment().format(),
          sort: 'endDate asc',
          limit: 1
        }
      }).then(({data}) => {
        if (data.items.length > 0) {
          commit('currentPeriod', data.items[0])
        } else {
          return http.get('periods', {
            params: {
              sort: 'endDate asc',
              limit: 1
            }
          }).then(({data}) => {
            if (data.items.length > 0) {
              commit('currentPeriod', data.items[0])
            }
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/charts/index.js